import { render } from "./history-upload.vue?vue&type=template&id=76d043b3&ts=true"
import script from "./history-upload.vue?vue&type=script&lang=ts"
export * from "./history-upload.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__